export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: 'https://lyrax.cl/contacto',
  DASHBOARD: '/dashboard',
  DASHBOARD_FINANCIERO: '/dashboard/financiero',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  USUARIOS: '/settings/usuarios',
  VIRTUAL_POS: '/payment-methods/virtual-pos',
  VIRTUAL_POS_KPIS: '/payment-methods/virtual-pos/kpis',
  PAYKU: '/payment-methods/payku',
  MANDATOS: '/payment-methods/mandatos',
} as const;

export type RouteType = typeof ROUTES[keyof typeof ROUTES];
